import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import { CircularProgress } from 'material-ui/Progress';
import Button from 'material-ui/Button';
import { FormControl, FormControlLabel } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { DatePicker, TimePicker } from 'material-ui-pickers';
import moment from 'moment';
import { filter, map, remove, union } from 'lodash'
import * as fileupload from '../../../actions/fileupload';

import ContainerHeader from '../../../components/ContainerHeader/index';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';

import * as meetingdetails from '../../../actions/meetingdetails';
import * as loadswitchercommittees from '../../../actions/teamdetails';
import * as toaster from '../../../actions/toaster';

import MUISelector from "../../muiselector";
import * as regData from '../../../../appConstants'
import TableCell from './tablecell'
import { arrayMove, SortableContainer } from 'react-sortable-hoc';

class AddMeeting extends Component {

    constructor(props) {
        super(props);
        this.state = {
            setValue: false,
            committee_id: Number(this.props.loginUser.data.committee_id),
            id: this.props.params.id,
            smeeting: {
                committee_id: this.props.loginUser.data.committee_id, headedby: '', meetingNumber: '', meetingName: '',
                m_Date: moment().format('YYYY-MM-DD'), m_Time: moment().format('HH:mm'), m_eDate: moment().format('YYYY-MM-DD'),
                m_eTime: moment().add(1, 'hours').format('HH:mm'), location: '', notes: '', meeting_user: [],
                fileres: []
            },
            isFileUploaded: false,
            newfile: '',
            isNotifyUser: false
        };
    }

    componentDidMount() {
        if (this.state.id) {

            // console.log("state id ",this.state)

            this.setState({ setValue: false })
            console.log('this.state.id', this.state.id)
            this.props.actions.getMeetingDetails(this.state.id);
        }
        else {
            this.props.actions.getTeamUserList(this.props.loginUser.data.committee_id);
            this.state.smeeting = {
                committee_id: this.props.loginUser.data.committee_id, headedby: '', meetingNumber: '', meetingName: '',
                m_Date: moment().format('YYYY-MM-DD'), m_Time: moment().format('HH:mm'), m_eDate: moment().format('YYYY-MM-DD'),
                m_eTime: moment().add(1, 'hours').format('HH:mm'), location: '', notes: '', meeting_user: []
            }
        }
        this.props.actions.loadswitchercommittees();
    }

    handleChange(field, e) {
        // console.log(field, e)

        if (field == "filedescription") {
            const newfile = Object.assign({}, this.state.newfile, { [field]: e.target.value });
            this.setState(Object.assign({}, this.state, { 'newfile': newfile }));
        }
        else {

            if (field == 'm_Time' || field == 'm_eTime') {
                // console.log(field, moment(e).format('HH:mm'))
                let smeeting = Object.assign({}, this.state.smeeting, { [field]: moment(e).format('HH:mm') });
                this.setState(Object.assign({}, this.state, { 'smeeting': smeeting }));
            }
            else if (field == 'm_Date' || field == 'm_eDate') {
                // console.log(field, moment(e).format('DD-MM-YYYY'))
                let smeeting = Object.assign({}, this.state.smeeting, { [field]: moment(e).format('YYYY-MM-DD') });
                this.setState(Object.assign({}, this.state, { 'smeeting': smeeting }));
            }
            else {
                // console.log(field, e.target.value)
                let smeeting = Object.assign({}, this.state.smeeting, { [field]: e.target.value });
                this.setState(Object.assign({}, this.state, { 'smeeting': smeeting }));
            }
        }
        // console.log(moment(moment(this.state.smeeting.m_Date).format('YYYY-MM-DD') + " " + this.state.smeeting.m_Time))
        // console.log(moment(moment(this.state.smeeting.m_eDate).format('YYYY-MM-DD') + " " + this.state.smeeting.m_eTime))
        // console.log(moment(moment(this.state.smeeting.m_Date).format('YYYY-MM-DD') + " " + this.state.smeeting.m_Time) > moment(moment(this.state.smeeting.m_eDate).format('YYYY-MM-DD') + " " + this.state.smeeting.m_eTime))
        // console.log('this.state', this.state)
    }

    handleFileSelected(file) {
        let filedescription = this.state.newfile.filedescription ? this.state.newfile.filedescription : ''
        let newfile = { 'filedescription': filedescription, 'file': file.target.files[0] }
        this.setState({ 'newfile': newfile });
        let formData = new FormData();
        formData.append('file', file.target.files[0])

        console.log('form data ', formData)

        this.props.actions.fileUpload(formData)
        this.setState({ isFileUploaded: true });
        if (this.refs.fileUpload)
            this.refs.fileUpload.value = null
    }

    handleNotifyUser() {
        this.setState({ isNotifyUser: true });
        console.log('handleNotifyUser called ', this.state.id);
        // if (this.state.smeeting.fileres != null && this.state.smeeting.fileres.length > 0) {
        //     var postdata = this.state.smeeting.fileres[0];

        //     postdata.id = this.state.id;
        this.props.actions.sendMMNotifyEmail(this.state.id);
        this.setState({ isNotifyUser: false });
        // }
    }

    updateMeetingMinutesFileUploadStatus() {
        console.log('updateMeetingMinutesFileUploadStatus called ', this.state.smeeting.fileres);
        if (this.state.smeeting.fileres != null && this.state.smeeting.fileres.length > 0) {
            var postdata = this.state.smeeting.fileres[0];

            postdata.id = this.state.id;
            this.props.actions.addMeetingMinutesFile(postdata)

        }
    }

    handleChangeTeam(e) {
        let smeeting = Object.assign({}, this.state.smeeting, { ['committee_id']: e.target.value });
        this.setState(Object.assign({}, this.state, { 'smeeting': smeeting }));
        this.setState({ committee_id: Number(e.target.value) })
        this.props.actions.getTeamUserList(e.target.value);

        this.props.loginUser.data.committee_id = e.target.value;
        this.props.actions.changePreferedTeamIdUser(this.props.loginUser.data)
    }

    async handleSubmit(e) {
        e.preventDefault();
        // console.log(this.state.smeeting)

        if (moment(moment().format('YYYY-MM-DD')) > moment(moment(this.state.smeeting.m_Date).format('YYYY-MM-DD')))
            this.props.actions.errorToasters('Start Date Cannot be lesser than Current Date');
        else if (moment(this.state.smeeting.m_Date) > moment(this.state.smeeting.m_eDate))
            this.props.actions.errorToasters("Start Date Cannot be Greater than End Date");
        else if (moment(this.state.smeeting.m_eDate) < moment(this.state.smeeting.m_Date))
            this.props.actions.errorToasters('End Date Canot be lesser than Start Date');
        //else if (moment() > moment(moment(this.state.smeeting.m_Date).format('YYYY-MM-DD') + " " + this.state.smeeting.m_Time))
        //this.props.actions.errorToasters("Start Time Canot be Lesser than Current Time");
        else if (moment(moment(this.state.smeeting.m_Date).format('YYYY-MM-DD') + " " + this.state.smeeting.m_Time) > moment(moment(this.state.smeeting.m_eDate).format('YYYY-MM-DD') + " " + this.state.smeeting.m_eTime))
            this.props.actions.errorToasters("Start Time Cannot be Greater than End Time");
        else if (moment(moment(this.state.smeeting.m_eDate).format('YYYY-MM-DD') + " " + this.state.smeeting.m_eTime) < moment(moment(this.state.smeeting.m_Date).format('YYYY-MM-DD') + " " + this.state.smeeting.m_Time))
            this.props.actions.errorToasters('End Time Cannot be lesser than Start Time');
        else {
            if (this.state.id) {
                let smeeting = this.state.smeeting;
                // console.log('meeting_user', this.state.smeeting.meeting_user);
                this.props.actions.updateMeetingDetails(smeeting);
            }
            else {
                this.props.actions.addMeetingDetails(this.state.smeeting);
            }
        }
        // console.log(this.state.smeeting)
    }

    gettime(time) {
        // console.log(moment(moment().format('YYYY-MM-DD') + ' ' + time))
        return moment(moment().format('YYYY-MM-DD') + ' ' + time);
    }

    // getUpdateFileDetails = (data) => {
    //     // console.log('getUpdateFileDetails', data)
    //     // Find item index using _.findIndex
    //     var index = _.findIndex(this.state.smeeting.fileres, { fileId: data.fileId });
    //     // Replace item at index using native splice
    //     this.state.smeeting.fileres.splice(index, 1, data);
    //     this.setState({ 'setValue': true });
    // }

    getUpdateFileDetails = (data) => {
        // console.log('getUpdateFileDetails', data)
        // Find item index using _.findIndex
        var index = _.findIndex(this.state.smeeting.fileres, { fileId: data.fileId });
        // Replace item at index using native splice
        this.state.smeeting.fileres.splice(index, 1, data);
        this.setState({ 'setValue': true });
    }
    getDeleteFileDetails = (data) => {

        console.log('getDeleteFileDetails data ', data);

        if (data && data.fileId) {
            // Find item index using _.findIndex
            var index = _.findIndex(this.state.smeeting.fileres, { fileId: data.fileId });
            // Replace item at index using native splice
            this.state.smeeting.fileres.splice(index, 1);
        }
        else if (data && data.tempFileId) {
            // Find item index using _.findIndex
            var index = _.findIndex(this.state.smeeting.fileres, { tempFileId: data.tempFileId });
            // Replace item at index using native splice
            this.state.smeeting.fileres.splice(index, 1);
        }
        this.setState({ 'setValue': true });
    }


    render() {
        const { match, loginUser, meetingDetails, params, teamDetails, fileupload } = this.props;
        // console.log('(meetingDetails && meetingDetails.Status)', (meetingDetails && meetingDetails.Status))
        let result = null;
        if ((meetingDetails && meetingDetails.Status) || (teamDetails && teamDetails.Status)) {
            result = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }


        if ((fileupload && fileupload.Status)) {
            result = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }

        if (this.state.isNotifyUser) {
            result = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }

        if (fileupload && fileupload.filedetails && this.state.isFileUploaded) {
            // console.log('After upload success',this.state.newfile)
            fileupload.filedetails.description = this.state.newfile.filedescription;
            if (!this.state.smeeting.fileres)
                this.state.smeeting.fileres = [];

            // console.log('s meeting file upload ', fileupload.filedetails);
            this.state.smeeting.fileres.push(fileupload.filedetails);
            this.setState({ isFileUploaded: false, newfile: '' });
            console.log('After upload success', this.state.smeeting.fileres)
            this.updateMeetingMinutesFileUploadStatus();
        }

        // if (meetingDetails && meetingDetails.apiPostResult) {

        //     console.log('Meeting minutes file created successfully');
        // }


        if (!this.state.smeeting.smeetingId && meetingDetails && meetingDetails.meetingdetails && !this.state.setValue) {
            this.state.smeeting = meetingDetails.meetingdetails;

            console.log('meeting details ', meetingDetails.meetingdetails)

            this.state.setValue = true;
            let committee_users = this.state.smeeting.committee_users;
            let meeting_user = this.state.smeeting.meeting_user;
            map(meeting_user, function (el) {
                remove(committee_users, { 'id': el.id })
            });
            this.state.smeeting.meeting_user = union(meeting_user, committee_users);
            // console.log('meeting_user', this.state.smeeting.meeting_user);
        }
        else if (teamDetails && teamDetails.teamuserList && teamDetails.apiGetResult && !this.state.id) {
            // console.log('meeting_user', this.state.smeeting.meeting_user);
            this.state.smeeting.meeting_user = teamDetails.teamuserList;
        }
        let _TeamList = null
        const committeeList = teamDetails.switchteamdetailsList;
        if (committeeList && committeeList.length > 0) {
            _TeamList = committeeList.map(team => (
                <MenuItem key={team.id} value={team.id}
                    style={{ fontWeight: '500' }}>
                    {team.name}
                </MenuItem>
            ))
            // this.setState({ committee_id: loginUser.data.committee_id })
        }

        const FileSortableList = SortableContainer(({ fileList }) => {
            if (!fileList || fileList == false)
                return (<tbody></tbody>)
            return (
                <tbody>
                    {fileList.map((file, index) => {
                        // console.log('tbl', index)
                        // <SortableUser key={index} index={index} user={user} />
                        return <TableCell key={index} data={file} i={index} index={index} getUpdateFileDetails={this.getUpdateFileDetails.bind(this)}
                            id={this.state.smeeting.smeetingId} committee_id={this.state.committee_id} getDeleteFileDetails={this.getDeleteFileDetails.bind(this)} />
                    })
                    }
                </tbody>
            );
        });
        return (
            <div className="slideInUpTiny ">
                {result}
                <ContainerHeader title="Add Meeting" match={match} />
                <div className="row mb-md-4">
                    <div className="col-12">

                        <ValidatorForm autoComplete="off" onSubmit={this.handleSubmit.bind(this)}>
                            <Card className="shadow border-0">

                                <CardHeader className="bg-white p-0">
                                    <div className="row p-2">
                                        <div className="col-6 pt-2 pl-4"> Meeting Details</div>
                                        <div className="col-2 text-right pt-2"> Team Name :</div>
                                        <div className="col-4">
                                            <FormControl className="w-100 mb-2 col-12">
                                                {/* <InputLabel htmlFor="age-simple">Team Switcher</InputLabel> */}
                                                <Select
                                                    value={this.state.committee_id}
                                                    onChange={this.handleChangeTeam.bind(this)}
                                                    input={<Input id="age-simple" />}
                                                    disabled={this.state.id ? true : false}
                                                >
                                                    {_TeamList}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    <div className="row">
                                        <div className="col-3">
                                            <TextValidator margin="normal" className="mt-0 mb-2 col-12"
                                                name="meetingNumber" label="Meeting Number"
                                                validators={['required', regData.regexExpEng, regData.regexExpEngLength]}
                                                errorMessages={['This field is required', regData.messageRegexEng, regData.messageLength]}
                                                value={this.state.smeeting.meetingNumber} onChange={this.handleChange.bind(this, 'meetingNumber')} />
                                        </div>
                                        <div className="col-6">
                                            <TextValidator margin="normal" className="mt-0 mb-2 col-12"
                                                name="meetingName" label="Meeting Name"
                                                validators={['required', regData.regexExp, regData.regexExpLength]}
                                                errorMessages={['This field is required', regData.messageRegexEx, regData.messageLength]}
                                                value={this.state.smeeting.meetingName} onChange={this.handleChange.bind(this, 'meetingName')} />
                                        </div>
                                        <div className="col-3">
                                            <TextValidator margin="normal" className="mt-0 mb-2 col-12"
                                                name="headedby" label="Headed By"
                                                validators={[regData.regexAlphaNumeric, regData.regexAlphaNumericLength]}
                                                errorMessages={[regData.messageAlphaNumeric, regData.messageLength]}
                                                value={this.state.smeeting.headedby} onChange={this.handleChange.bind(this, 'headedby')} />
                                        </div>
                                        <div className="col-3">
                                            <DatePicker fullWidth
                                                value={this.state.smeeting.m_Date ? moment(this.state.smeeting.m_Date) : moment()}
                                                onChange={this.handleChange.bind(this, 'm_Date')}
                                                animateYearScrolling={false} label="Start Date"
                                                format="DD/MM/YYYY"
                                                leftArrowIcon={<i className="zmdi zmdi-arrow-back" />} rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />} />
                                        </div>
                                        <div className="col-3">
                                            <DatePicker fullWidth
                                                value={this.state.smeeting.m_eDate ? moment(this.state.smeeting.m_eDate) : moment()}
                                                onChange={this.handleChange.bind(this, 'm_eDate')}
                                                animateYearScrolling={false} label="End Date"
                                                format="DD/MM/YYYY"
                                                leftArrowIcon={<i className="zmdi zmdi-arrow-back" />} rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />} />
                                        </div>

                                        <div className="col-3">
                                            <TimePicker fullWidth value={this.gettime(this.state.smeeting.m_Time)}
                                                label="Start Time"
                                                onChange={this.handleChange.bind(this, 'm_Time')} />
                                        </div>
                                        <div className="col-3">
                                            <TimePicker fullWidth value={this.gettime(this.state.smeeting.m_eTime)}
                                                label="End Time"
                                                onChange={this.handleChange.bind(this, 'm_eTime')} />
                                        </div>

                                        <div className="col-7">
                                            <TextValidator margin="normal" className="mt-0 mb-2 col-12"
                                                name="location" label="Location"
                                                validators={['required', regData.regexExp, regData.regexExpLength]}
                                                errorMessages={['This field is required', regData.messageRegexEx, regData.messageLength]}
                                                value={this.state.smeeting.location} onChange={this.handleChange.bind(this, 'location')} />
                                        </div>
                                        <div className="col-12">
                                            <MUISelector userList={this.state.smeeting.meeting_user} />
                                        </div>
                                        <div className="col-8">
                                            <TextValidator margin="normal" className="mt-0 mb-4 col-md-12"
                                                name="notes" label="Notes" multiline
                                                validators={[regData.regexMultiLineExp, regData.regexMultiLineExpLength]}
                                                errorMessages={[regData.messageMultilineRegexEx, regData.messageMultilineLength]}
                                                value={this.state.smeeting.notes} onChange={this.handleChange.bind(this, 'notes')} />
                                        </div>
                                    </div>
                                    {this.state.id ?
                                        <Card className="">
                                            <div class="pl-3 p-2 bg-primary text-center text-white card-header">
                                                <h3 className="card-title">Meeting Minutes File <p class="meeting-auto">(Auto publish to all attentees once the upload is complete)*</p></h3>

                                            </div>
                                            <CardBody>
                                                <div className="row">
                                                    <div className="col-md-12">

                                                    </div>
                                                    {(this.state.id && !this.state.smeeting.fileres.length > 0) ?
                                                        <div className="col-12">
                                                            {/* <div className="col-md-8">
                                                                <TextValidator margin="normal" className="mt-0 mb-4 col-md-12"
                                                                    name="filedescription" label="File Description" multiline={true}
                                                                    validators={[regData.regexMultiLineExp, regData.regexMultiLineExpLength]}
                                                                    errorMessages={[regData.messageMultilineRegexEx, regData.messageMultilineLength]}
                                                                    value={this.state.newfile ? this.state.newfile.filedescription : ''} onChange={this.handleChange.bind(this, 'filedescription')} />
                                                            </div> */}

                                                            <div className="col-4">
                                                                <div className="input-group mb-3">
                                                                </div>



                                                                <input type="file" accept="application/pdf" id="fileUpload" ref="fileUpload" className="hidden" onChange={this.handleFileSelected.bind(this)} />
                                                                <label htmlFor="fileUpload">
                                                                    <Button variant="raised" component="span" className="jr-btn bg-primary text-white">Choose file</Button>
                                                                    <p class="pt-2">(You can upload pdf format only and the file size should not exceed 100MB)</p>
                                                                </label>

                                                                {/*  */}
                                                                <label className="m-2">{this.state.newfile && this.state.newfile.file ? this.state.newfile.file.name : ""}</label>
                                                            </div>
                                                        </div>
                                                        : <div></div>}

                                                    {(this.state.id && this.state.smeeting.fileres.length > 0) ?

                                                        <div className="col-md-12">

                                                            {/* <input type="button" id="notifyUser" ref="notifyUser" className="hidden" onChange={this.handleNotifyUser.bind(this)} />
                                                            <label htmlFor="notifyUser"> */}
                                                            <Button variant="raised" component="span" className="jr-btn bg-primary text-white" onClick={this.handleNotifyUser.bind(this)}>Notify Attendee</Button>
                                                            <p class="pt-2">(Notify all the Meeting Attendees)</p>
                                                            {/* </label> */}
                                                            <div className="table-responsive-material">
                                                                <table className="default-table table-unbordered table table-lg table-hover">
                                                                    <thead className="th-border-b">
                                                                        <tr>
                                                                            <th>Sort</th>
                                                                            <th>S.No.</th>
                                                                            <th>File Name</th>
                                                                            {/* <th>Description</th> */}
                                                                            <th className="status-cell text-right">Actions</th>
                                                                            <th />
                                                                        </tr>
                                                                    </thead>
                                                                    {/* <tbody> */}
                                                                    {/* {_fileList} */}
                                                                    <FileSortableList fileList={this.state.smeeting.fileres}
                                                                        onSortEnd={this.onSortEnd} useDragHandle={true} />
                                                                    {/* </tbody> */}
                                                                </table>
                                                            </div>
                                                        </div>
                                                        : <div></div>}
                                                </div>

                                            </CardBody>
                                        </Card>
                                        : null}

                                </CardBody>
                            </Card>
                            <div className="col-12">
                                {!this.state.id && <Button type='submit' variant="raised" className="jr-btn bg-primary text-white">Save</Button>}
                                {this.state.id && <Button type='submit' variant="raised" className="jr-btn bg-primary text-white">Update Meeting</Button>}

                                {this.state.id && <Button variant="raised" className="jr-btn bg-primary text-white" onClick={() => { this.props.history.push('/meeting/meeting-list') }}>Save Meeting Minutes</Button>}

                                <Button variant="raised" className="jr-btn bg-grey text-white" onClick={() => { this.props.history.push('/meeting/meeting-list') }}>Cancel</Button>
                            </div>
                        </ValidatorForm>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    // console.log(ownProps)
    const { loginUser, teamDetails, meetingDetails, fileupload } = state;
    const { match } = ownProps;
    return { match, loginUser, teamDetails, meetingDetails, params: ownProps.match.params, fileupload }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, loadswitchercommittees, meetingdetails, fileupload, toaster), dispatch)
    };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddMeeting));



// WEBPACK FOOTER //
// ./app/meetingdetails/addmeetingNew/index.js